export { default } from "./StatusBar.js";